import '@/assets/styles/views/solver/web-direction.scss';

const WebDirection = () => {
	return (
		<div className="web-direction-container">
			<img src="/assets/solver-web-direction.png" />
			<h1 className="title">Çözücü Yalnızca Bilgisayarda Kullanılabilir!</h1>
			<p className="description">Çözücü ilk olarak bilgisayardan kullanıma sunuldu. Mobil deneyim çok yakında! Şimdilik bilgisayardan giriş yaparak soru göndermeye başlayabilirsin.</p>
		</div>
	);
};

export default WebDirection;
